import HomeContainer from "../HomeContainer/HomeContainer";

import { SkeletonBox } from "../../common/Skeleton";

export default function HeroSliderSkeleton() {
  return (
    <HomeContainer>
      <section className="home-hero-slider-skeleton">
        <SkeletonBox width="100%" height="420px" radius={18} />
      </section>
    </HomeContainer>
  );
}
